//import React, { useState, useEffect } from "react";
//import HoaNavbar from "../HoaNavbar/HoaNavbar";
//import HoaFooter from "../HoaFooter/HoaFooter";
//import { AiOutlineCloudUpload } from "react-icons/ai";
//import { useHistory } from "react-router-dom";
//import axios from "axios";
//import { API_URL } from "../../apiConfig";
//import LoadingComman from "../Loading/LoadingCommon";
//import PhoneInput from "react-phone-input-2";
//import "react-phone-input-2/lib/style.css";

//const HoaVendorOnBoard = () => {
//  const history = useHistory();

//  // Consolidated useEffect for fetching countries and business types
//  useEffect(() => {
//    // Fetch countries
//    axios
//      .get(`${API_URL}/public/country/getAll`)
//      .then((response) => {
//        setCountryData(response.data);
//      })
//      .catch((error) => {
//        console.error("Error fetching countries:", error);
//      });

//    // Fetch business types
//    axios
//      .get(`${API_URL}/public/servicetype/getAll`)
//      .then((response) => {
//        setBusinessTypes(response.data);
//      })
//      .catch((error) => {
//        console.error("Error fetching business types:", error);
//      });

//    // Fetch states
//    axios
//      .get(`${API_URL}/public/state/getAll`)
//      .then((response) => {
//        setStateData(response.data);
//      })
//      .catch((error) => {
//        console.error("Error fetching states:", error);
//      });
//  }, []);

//  const getCurrentDate = () => {
//    const date = new Date();
//    return date.toISOString();
//  };

//  const INITIAL_FORM_STATE = {
//    communityAddressDTO: {
//      address: "",
//      city: "",
//      stateId: null,
//      addressId: 0,
//      countryId: null,
//      zipCode: "",
//      activeStatus: true,
//    },
//    companyAddressDTO: {
//      address: "",
//      city: "",
//      stateId: 0,
//      addressId: 0,
//      countryId: 0,
//      zipCode: "",
//      activeStatus: true,
//    },
//    vendorDTO: {
//      activeStatus: true,
//      companyName: "",
//      name: "",
//      emailId: "",
//      phone: "",
//      businessEmailId: "",
//      businessPhone: "",
//      taxId: "",
//      comments: "",
//      isAcceptCcPayment: null,
//      licenseExpiryDate: "",
//      licenceNumber: "",
//      insuranceNumber: "",
//      isPropertyNeeded: true,
//      createdById: null,
//      modifiedById: null,
//      createdDate: getCurrentDate(),
//      modifiedDate: getCurrentDate(),
//      serviceTypeId: 0,
//      communityAddressId: 0,
//      companyAddressId: 0,
//      vendorId: 0,
//      zipCode: "",
//      vendorCode: "",
//      insuranceDocument: null,
//      licenceDocument: null,
//    },
//  };

//  const [formData, setFormData] = useState(INITIAL_FORM_STATE);
//  const [selectedCountryId, setSelectedCountryId] = useState("");
//  const [selectedCommunityCountryId, setSelectedCommunityCountryId] = useState("");
//  const [countryData, setCountryData] = useState([]);
//  const [stateData, setStateData] = useState([]);
//  const [showInsuranceDetails, setShowInsuranceDetails] = useState(false);
//  const [showLicenseDetails, setShowLicenseDetails] = useState(false);
//  const [loadingComman, setLoadingComman] = useState(false);
//  const [errors, setErrors] = useState({});
//  const [businessTypes, setBusinessTypes] = useState([]);
//  const [needAccess, setNeedAccess] = useState("");
//  const [workingForCommunity, setWorkingForCommunity] = useState("");
//  const [selectedInsuranceFile, setSelectedInsuranceFile] = useState(null);
//  const [selectedLicenseFile, setSelectedLicenseFile] = useState(null);

//  const resetFormState = () => {
//    setFormData(INITIAL_FORM_STATE);
//    setErrors({});
//    setShowLicenseDetails(false);
//    setShowInsuranceDetails(false);
//    setNeedAccess("");
//    setWorkingForCommunity("");
//    setSelectedInsuranceFile(null);
//    setSelectedLicenseFile(null);
//  };

//  const handleChange = (event) => {
//    const { name, value, type, checked } = event.target;

//    setFormData((prevFormData) => {
//      const updatedFormData = { ...prevFormData };

//      if (name === "companyAddressDTO.countryId") {
//        setSelectedCountryId(parseInt(value, 10) || "");
//      }
//      if (name === "communityAddressDTO.countryId") {
//        setSelectedCommunityCountryId(parseInt(value, 10) || "");
//      }

//      const nameParts = name.split(".");
//      if (nameParts.length > 1) {
//        const [category, key] = nameParts;

//        const numericFields = {
//          companyAddressDTO: ["countryId", "stateId"],
//          communityAddressDTO: ["countryId", "stateId"],
//          vendorDTO: ["serviceTypeId"],
//        };

//        const shouldConvertToNumber = numericFields[category]?.includes(key);
//        const updatedValue = shouldConvertToNumber
//          ? value === "" ? "" : parseInt(value, 10)
//          : type === "checkbox"
//            ? checked
//            : value;

//        updatedFormData[category] = {
//          ...updatedFormData[category],
//          [key]: updatedValue,
//        };
//      }

//      return updatedFormData;
//    });
//  };

//  const handleAcceptCCPaymentChange = (event) => {
//    const { value } = event.target;
//    setFormData((prevFormData) => ({
//      ...prevFormData,
//      vendorDTO: {
//        ...prevFormData.vendorDTO,
//        isAcceptCcPayment: value === "true",
//      },
//    }));
//  };

//  const handleInsuranceChange = (e) => {
//    setShowInsuranceDetails(e.target.value === "yes");
//  };

//  const handleLicenseChange = (e) => {
//    setShowLicenseDetails(e.target.value === "yes");
//  };

//  const handleAccessChange = (e) => {
//    setNeedAccess(e.target.value);
//  };

//  const handleCommunityWorkChange = (e) => {
//    setWorkingForCommunity(e.target.value);
//  };

//  const handleKeyPress = (e) => {
//    if (!/[0-9]/.test(e.key)) {
//      e.preventDefault();
//    }
//  };

//  const handlePhoneNumberChange = (name, value) => {
//    setFormData((prevFormData) => ({
//      ...prevFormData,
//      vendorDTO: {
//        ...prevFormData.vendorDTO,
//        [name]: value,
//      },
//    }));
//  };

//  const validateForm = async () => {
//    let isValid = true;
//    const newErrors = {};

//    const isEmpty = (value) =>
//      value === null || value === undefined || (typeof value === "string" && !value.trim());

//    const isValidPhoneNumber = (phoneNumber) => phoneNumber && phoneNumber.length >= 10;

//    const isValidEmail = (email) =>
//      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

//    const isValidLicenseNumber = (licenseNumber) => /^DL14\s\d{11}$/.test(licenseNumber);

//    if (isEmpty(formData.vendorDTO.companyName)) {
//      newErrors.companyName = "Please provide your company name.";
//      isValid = false;
//    }
//    if (formData.vendorDTO.isAcceptCcPayment === null) {
//      newErrors.isAcceptCcPayment = "Please specify if you accept CC payment.";
//      isValid = false;
//    }
//    if (isEmpty(formData.vendorDTO.name)) {
//      newErrors.name = "Please provide your name.";
//      isValid = false;
//    }
//    if (!isValidPhoneNumber(formData.vendorDTO.businessPhone)) {
//      newErrors.businessPhone = "Please enter a valid business phone number.";
//      isValid = false;
//    }
//    if (!isValidPhoneNumber(formData.vendorDTO.phone)) {
//      newErrors.phone = "Please enter a valid phone number.";
//      isValid = false;
//    }
//    if (isEmpty(formData.vendorDTO.businessEmailId) || !isValidEmail(formData.vendorDTO.businessEmailId)) {
//      newErrors.businessEmailId = "Please provide a valid email address.";
//      isValid = false;
//    } else {
//      const isEmailAvailable = await handleEmailCheck(formData.vendorDTO.businessEmailId);
//      if (isEmailAvailable) {
//        newErrors.businessEmailId = "Email is already taken.";
//        isValid = false;
//      }
//    }
//    if (isEmpty(formData.vendorDTO.emailId) || !isValidEmail(formData.vendorDTO.emailId)) {
//      newErrors.emailId = "Please provide a valid email address.";
//      isValid = false;
//    } else {
//      const isEmailAvailable = await handleEmailCheck(formData.vendorDTO.emailId);
//      if (isEmailAvailable) {
//        newErrors.emailId = "Email is already taken.";
//        isValid = false;
//      }
//    }
//    if (formData.vendorDTO.businessEmailId && formData.vendorDTO.emailId && formData.vendorDTO.businessEmailId === formData.vendorDTO.emailId) {
//      newErrors.emailId = "Business and personal email IDs cannot be the same.";
//      isValid = false;
//    }
//    if (isEmpty(formData.vendorDTO.taxId)) {
//      newErrors.taxId = "Please provide your tax ID.";
//      isValid = false;
//    } else if (!/^\d{10}$/.test(formData.vendorDTO.taxId)) {
//      newErrors.taxId = "Tax ID must be exactly 10 digits.";
//      isValid = false;
//    }
//    if (isEmpty(formData.vendorDTO.comments)) {
//      newErrors.comments = "Please provide your comments.";
//      isValid = false;
//    }
//    if (isEmpty(formData.vendorDTO.licenseExpiryDate)) {
//      newErrors.licenseExpiryDate = "Please provide the license expiry date.";
//      isValid = false;
//    }
//    if (isEmpty(formData.vendorDTO.licenceNumber) || !isValidLicenseNumber(formData.vendorDTO.licenceNumber)) {
//      newErrors.licenceNumber = "License number must be in the format DL14 20110012345.";
//      isValid = false;
//    }
//    if (isEmpty(formData.vendorDTO.insuranceNumber)) {
//      newErrors.insuranceNumber = "Please provide the insurance number.";
//      isValid = false;
//    }
//    if (formData.vendorDTO.serviceTypeId === 0) {
//      newErrors.serviceTypeId = "Please select a service type.";
//      isValid = false;
//    }
//    if (isEmpty(formData.companyAddressDTO.address)) {
//      newErrors.companyAddress = "Please provide the company address.";
//      isValid = false;
//    }
//    if (isEmpty(formData.communityAddressDTO.address)) {
//      newErrors.communityAddress = "Please provide the community address.";
//      isValid = false;
//    }
//    if (!formData.companyAddressDTO.countryId) {
//      newErrors.companyCountryId = "Please select a company country.";
//      isValid = false;
//    }
//    if (!formData.communityAddressDTO.countryId) {
//      newErrors.communityCountryId = "Please select a community country.";
//      isValid = false;
//    }
//    if (!formData.companyAddressDTO.stateId) {
//      newErrors.companyStateId = "Please select a company state.";
//      isValid = false;
//    }
//    if (!formData.communityAddressDTO.stateId) {
//      newErrors.communityStateId = "Please select a community state.";
//      isValid = false;
//    }
//    if (isEmpty(formData.companyAddressDTO.city)) {
//      newErrors.companyCity = "Please provide the company city.";
//      isValid = false;
//    }
//    if (isEmpty(formData.communityAddressDTO.city)) {
//      newErrors.communityCity = "Please provide the community city.";
//      isValid = false;
//    }
//    if (isEmpty(formData.companyAddressDTO.zipCode)) {
//      newErrors.companyZipCode = "Please provide the company zip code.";
//      isValid = false;
//    }
//    if (isEmpty(formData.vendorDTO.zipCode)) {
//      newErrors.vendorZipCode = "Please provide the vendor zip code.";
//      isValid = false;
//    }
//    if (isEmpty(formData.communityAddressDTO.zipCode)) {
//      newErrors.communityZipCode = "Please provide the community zip code.";
//      isValid = false;
//    }

//    setErrors(newErrors);
//    return isValid;
//  };

//  const handleBlur = (e) => {
//    const { name, value } = e.target;
//    const [object, key] = name.split(".");

//    if (key === "licenceNumber") {
//      if (!validateLicenceNumber(value)) {
//        setErrors((prevErrors) => ({
//          ...prevErrors,
//          licenceNumber: "License number must be in the format DL14 20110012345.",
//        }));
//      } else {
//        setErrors((prevErrors) => ({
//          ...prevErrors,
//          licenceNumber: "",
//        }));
//      }
//    }
//  };

//  const handleFileChange = (event, type) => {
//    if (type === "insurance") {
//      setSelectedInsuranceFile(event.target.files[0]);
//    } else if (type === "license") {
//      setSelectedLicenseFile(event.target.files[0]);
//    }
//  };

//  const displayValue = (value) => {
//    return value === "" || value === 0 ? "" : value;
//  };

//  const handleEmailCheck = async (email) => {
//    try {
//      const response = await axios.get(`${API_URL}/user/check/email?emailId=${email}`);
//      return response.status !== 200; // Return false if email exists (200), true if available
//    } catch (error) {
//      console.error("Error checking email:", error);
//      return true; // Assume available on error to avoid blocking submission
//    }
//  };

//  const handleSubmit = async (e) => {
//    e.preventDefault();
//    const isValid = await validateForm();

//    if (isValid) {
//      setLoadingComman(true);
//      let insuranceDocUrl = null;
//      let licenseDocUrl = null;

//      try {
//        if (selectedInsuranceFile) {
//          const insuranceFormData = new FormData();
//          insuranceFormData.append("file", selectedInsuranceFile);
//          const insuranceUploadResponse = await axios.post(
//            `${API_URL}/public/vendor/insuranceUpload`,
//            insuranceFormData,
//            { headers: { "Content-Type": "multipart/form-data" } }
//          );
//          insuranceDocUrl = insuranceUploadResponse.data;
//        }

//        if (selectedLicenseFile) {
//          const licenseFormData = new FormData();
//          licenseFormData.append("file", selectedLicenseFile);
//          const licenseUploadResponse = await axios.post(
//            `${API_URL}/public/vendor/licenceUpload`,
//            licenseFormData,
//            { headers: { "Content-Type": "multipart/form-data" } }
//          );
//          licenseDocUrl = licenseUploadResponse.data;
//        }

//        const updatedFormData = {
//          ...formData,
//          vendorDTO: {
//            ...formData.vendorDTO,
//            insuranceDocument: insuranceDocUrl,
//            licenceDocument: licenseDocUrl,
//          },
//        };

//        const response = await axios.post(`${API_URL}/public/vendor/add`, updatedFormData);
//        alert("Form submitted successfully!");
//        resetFormState();
//        history.push("/"); // Redirect to home or another page
//      } catch (error) {
//        console.error("Error submitting form:", error.response?.data || error.message);
//        alert("Failed to submit form. Please try again or contact support.");
//      } finally {
//        setLoadingComman(false);
//      }
//    } else {
//      alert("Please fill in all required fields correctly.");
//    }
//  };

//  const handleCancel = () => {
//    resetFormState();
//    history.push("/"); // Redirect instead of reloading
//  };

//  const validateLicenceNumber = (licenceNumber) => {
//    const regex = /^DL14\s\d{11}$/;
//    return regex.test(licenceNumber);
//  };

//  return (
//    <>
//      <div className="fixed top-0 w-full z-50">
//        <HoaNavbar />
//      </div>
//      {loadingComman && <LoadingComman />}
//      {!loadingComman && (
//        <div className="mt-[70px] min-h-screen bg-gray-50 py-8">
//          <div className="bg-blue-800 text-white w-[85%] mx-auto my-5 py-5 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.3)] rounded-lg">
//            <div className="w-[85%] mx-auto my-5 flex flex-col gap-5">
//              <div className="flex text-white">
//                <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                  <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//                </svg>
//              </div>
//              <h2 className="text-white text-2xl font-bold">Vendor Onboarding</h2>
//              <p className="text-base flex gap-2.5 items-center text-white">
//                Please enter your info below. * is mandatory
//              </p>
//            </div>

//            <form onSubmit={handleSubmit}>
//              <div className="w-[85%] mx-auto flex flex-wrap items-start gap-5 py-2.5">

//                {/* Company Name */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="companyName" className="block mb-1 text-white">Company Name *</label>
//                  <input
//                    type="text"
//                    name="vendorDTO.companyName"
//                    id="companyName"
//                    placeholder="Company Name"
//                    value={formData.vendorDTO.companyName}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={100}
//                  />
//                  {errors.companyName && <p className="text-white text-sm mt-1">{errors.companyName}</p>}
//                </div>

//                {/* Business Phone */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="businessPhone" className="block mb-1 text-white">Business Phone Number *</label>
//                  <PhoneInput
//                    placeholder="Enter business phone number"
//                    value={formData.vendorDTO.businessPhone}
//                    onChange={(value) => handlePhoneNumberChange("businessPhone", value)}
//                    country="us"
//                    containerClass="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none text-black text-base transition-all duration-150 ease-in-out border-none bg-white"
//                    inputClass="phone-input"
//                    inputStyle={{
//                      width: '100%',
//                      height: '42px',
//                      fontSize: '16px',
//                      borderRadius: '8px',
//                      border: 'none',
//                      outline: 'none',
//                      backgroundColor: 'white',
//                      color: 'black'
//                    }}
//                  />
//                  {errors.businessPhone && <p className="text-white text-sm mt-1">{errors.businessPhone}</p>}
//                </div>

//                {/* Business Email */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="businessEmailId" className="block mb-1 text-white">Business Email Address *</label>
//                  <input
//                    type="email"
//                    name="vendorDTO.businessEmailId"
//                    id="businessEmailId"
//                    placeholder="Business Email Address"
//                    value={formData.vendorDTO.businessEmailId}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={100}
//                  />
//                  {errors.businessEmailId && <p className="text-white text-sm mt-1">{errors.businessEmailId}</p>}
//                </div>

//                {/* Business Type */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="serviceTypeId" className="block mb-1 text-white">Type of Business *</label>
//                  <select
//                    name="vendorDTO.serviceTypeId"
//                    id="serviceTypeId"
//                    value={formData.vendorDTO.serviceTypeId}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  >
//                    <option value="">Select Type of Business</option>
//                    {businessTypes.map((type) => (
//                      <option key={type.id} value={type.id}>
//                        {type.name}
//                      </option>
//                    ))}
//                  </select>
//                  {errors.serviceTypeId && <p className="text-white text-sm mt-1">{errors.serviceTypeId}</p>}
//                </div>

//                {/* Tax ID */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="taxId" className="block mb-1 text-white">Enter your tax ID *</label>
//                  <input
//                    type="text"
//                    name="vendorDTO.taxId"
//                    id="taxId"
//                    placeholder="Tax ID"
//                    value={formData.vendorDTO.taxId}
//                    onChange={handleChange}
//                    maxLength={10}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    onKeyPress={handleKeyPress}
//                  />
//                  {errors.taxId && <p className="text-white text-sm mt-1">{errors.taxId}</p>}
//                </div>

//                {/* Company Zip Code */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="companyZipCode" className="block mb-1 text-white">Company Zip Code *</label>
//                  <input
//                    type="text"
//                    name="companyAddressDTO.zipCode"
//                    id="companyZipCode"
//                    placeholder="Zip Code"
//                    value={formData.companyAddressDTO.zipCode}
//                    onChange={handleChange}
//                    pattern="\d*"
//                    inputMode="numeric"
//                    maxLength={10}
//                    onKeyPress={handleKeyPress}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  />
//                  {errors.companyZipCode && <p className="text-white text-sm mt-1">{errors.companyZipCode}</p>}
//                </div>

//                {/* Company Address */}
//                <div className="w-full">
//                  <label htmlFor="address" className="block mb-1 text-white">Company Address *</label>
//                  <input
//                    type="text"
//                    name="companyAddressDTO.address"
//                    id="address"
//                    placeholder="Company Address"
//                    value={formData.companyAddressDTO.address}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={100}
//                  />
//                  {errors.companyAddress && <p className="text-white text-sm mt-1">{errors.companyAddress}</p>}
//                </div>

//                {/* Company City */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="city" className="block mb-1 text-white">City *</label>
//                  <input
//                    type="text"
//                    name="companyAddressDTO.city"
//                    id="companycity"
//                    placeholder="City"
//                    value={formData.companyAddressDTO.city}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={100}
//                  />
//                  {errors.companyCity && <p className="text-white text-sm mt-1">{errors.companyCity}</p>}
//                </div>

//                {/* Company Country */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="country" className="block mb-1 text-white">Country *</label>
//                  <select
//                    id="countryId"
//                    name="companyAddressDTO.countryId"
//                    value={formData.companyAddressDTO.countryId || ""}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  >
//                    <option value="">Select Country</option>
//                    {countryData?.map((country) => (
//                      <option key={country.countryId} value={country.countryid}>
//                        {country.countryname}
//                      </option>
//                    ))}
//                  </select>
//                  {errors.companyCountryId && <p className="text-white text-sm mt-1">{errors.companyCountryId}</p>}
//                </div>

//                {/* Company State */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="state" className="block mb-1 text-white">State *</label>
//                  <select
//                    id="stateId"
//                    name="companyAddressDTO.stateId"
//                    value={formData.companyAddressDTO.stateId || ""}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  >
//                    <option value="">Select State</option>
//                    {stateData
//                      .filter((state) => state.countryid === parseInt(selectedCountryId))
//                      .map((state) => (
//                        <option key={state.stateid} value={state.stateid}>
//                          {state.statename}
//                        </option>
//                      ))}
//                  </select>
//                  {errors.companyStateId && <p className="text-white text-sm mt-1">{errors.companyStateId}</p>}
//                </div>

//                {/* Insurance Number */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="insuranceNumber" className="block mb-1 text-white">Insurance Number *</label>
//                  <input
//                    type="text"
//                    name="vendorDTO.insuranceNumber"
//                    id="insuranceNumber"
//                    placeholder="Insurance Number"
//                    value={formData.vendorDTO.insuranceNumber}
//                    onChange={handleChange}
//                    maxLength={50}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  />
//                  {errors.insuranceNumber && <p className="text-white text-sm mt-1">{errors.insuranceNumber}</p>}
//                </div>

//                {/* License Number */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="licenceNumber" className="block mb-1 text-white">License Number *</label>
//                  <input
//                    type="text"
//                    name="vendorDTO.licenceNumber"
//                    id="licenceNumber"
//                    placeholder="License Number (e.g., DL14 20110012345)"
//                    value={formData.vendorDTO.licenceNumber}
//                    onChange={handleChange}
//                    onBlur={handleBlur}
//                    maxLength={50}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  />
//                  {errors.licenceNumber && <p className="text-white text-sm mt-1">{errors.licenceNumber}</p>}
//                </div>

//                {/* License Expiry Date */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="licenseExpiryDate" className="block mb-1 text-white">License Expiry Date *</label>
//                  <input
//                    type="date"
//                    name="vendorDTO.licenseExpiryDate"
//                    id="licenseExpiryDate"
//                    value={formData.vendorDTO.licenseExpiryDate}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    min={new Date().toISOString().split("T")[0]}
//                  />
//                  {errors.licenseExpiryDate && <p className="text-white text-sm mt-1">{errors.licenseExpiryDate}</p>}
//                </div>

//                {/* Comments */}
//                <div className="w-full">
//                  <label htmlFor="comments" className="block mb-1 text-white">Comments *</label>
//                  <textarea
//                    name="vendorDTO.comments"
//                    id="comments"
//                    placeholder="Comments"
//                    value={formData.vendorDTO.comments}
//                    onChange={handleChange}
//                    maxLength={200}
//                    className="w-full h-[100px] rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm resize-none"
//                  />
//                  {errors.comments && <p className="text-white text-sm mt-1">{errors.comments}</p>}
//                </div>

//                {/* CC Payment Radio */}
//                <div className="w-full">
//                  <label className="block mb-1 text-white">Do you accept CC payment? *</label>
//                  <div className="flex gap-5">
//                    <label className="text-xl bg-transparent leading-tight grid grid-cols-[1em_auto] gap-2 text-white cursor-pointer">
//                      <input
//                        type="radio"
//                        name="vendorDTO.isAcceptCcPayment"
//                        value={true}
//                        checked={formData.vendorDTO.isAcceptCcPayment === true}
//                        onChange={handleAcceptCCPaymentChange}
//                        className="appearance-none bg-white w-4 h-4 border-2 border-gray-300 rounded-full checked:bg-blue-800 checked:border-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2"
//                      />
//                      Yes
//                    </label>
//                    <label className="text-xl bg-transparent leading-tight grid grid-cols-[1em_auto] gap-2 text-white cursor-pointer">
//                      <input
//                        type="radio"
//                        name="vendorDTO.isAcceptCcPayment"
//                        value={false}
//                        checked={formData.vendorDTO.isAcceptCcPayment === false}
//                        onChange={handleAcceptCCPaymentChange}
//                        className="appearance-none bg-white w-4 h-4 border-2 border-gray-300 rounded-full checked:bg-blue-800 checked:border-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2"
//                      />
//                      No
//                    </label>
//                  </div>
//                  {errors.isAcceptCcPayment && <p className="text-white text-sm mt-1">{errors.isAcceptCcPayment}</p>}
//                </div>

//                {/* Community Info Header */}
//                <div className="w-full">
//                  <p className="text-white text-base">Specify the community Name, Address.</p>
//                </div>

//                {/* Name */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="name" className="block mb-1 text-white">Name *</label>
//                  <input
//                    type="text"
//                    name="vendorDTO.name"
//                    id="name"
//                    placeholder="Name"
//                    value={formData.vendorDTO.name}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={50}
//                  />
//                  {errors.name && <p className="text-white text-sm mt-1">{errors.name}</p>}
//                </div>

//                {/* Phone */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="phone" className="block mb-1 text-white">Phone Number *</label>
//                  <PhoneInput
//                    placeholder="Enter phone number"
//                    value={formData.vendorDTO.phone}
//                    onChange={(value) => handlePhoneNumberChange("phone", value)}
//                    country="us"
//                    containerClass="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none text-black text-base transition-all duration-150 ease-in-out border-none bg-white"
//                    inputClass="phone-input"
//                    inputStyle={{
//                      width: '100%',
//                      height: '42px',
//                      fontSize: '16px',
//                      borderRadius: '8px',
//                      border: 'none',
//                      outline: 'none',
//                      backgroundColor: 'white',
//                      color: 'black'
//                    }}
//                  />
//                  {errors.phone && <p className="text-white text-sm mt-1">{errors.phone}</p>}
//                </div>

//                {/* Email */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="emailId" className="block mb-1 text-white">Email Address *</label>
//                  <input
//                    type="email"
//                    name="vendorDTO.emailId"
//                    id="emailId"
//                    placeholder="Email Address"
//                    value={formData.vendorDTO.emailId}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={100}
//                  />
//                  {errors.emailId && <p className="text-white text-sm mt-1">{errors.emailId}</p>}
//                </div>

//                {/* Vendor Zip Code */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="vendorZipCode" className="block mb-1 text-white">Vendor Zip Code *</label>
//                  <input
//                    name="vendorDTO.zipCode"
//                    id="vendorZipCode"
//                    placeholder="Vendor Zip Code"
//                    type="text"
//                    onChange={handleChange}
//                    value={formData.vendorDTO.zipCode}
//                    pattern="\d*"
//                    inputMode="numeric"
//                    maxLength={10}
//                    onKeyPress={handleKeyPress}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  />
//                  {errors.vendorZipCode && <p className="text-white text-sm mt-1">{errors.vendorZipCode}</p>}
//                </div>

//                {/* Community Address */}
//                <div className="w-full">
//                  <label htmlFor="communityAddress" className="block mb-1 text-white">Community Address *</label>
//                  <input
//                    type="text"
//                    id="communityAddress"
//                    placeholder="Community Address"
//                    name="communityAddressDTO.address"
//                    value={formData.communityAddressDTO.address}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={200}
//                  />
//                  {errors.communityAddress && <p className="text-white text-sm mt-1">{errors.communityAddress}</p>}
//                </div>

//                {/* Community Country */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="communityCountryId" className="block mb-1 text-white">Country *</label>
//                  <select
//                    id="communityCountryId"
//                    name="communityAddressDTO.countryId"
//                    value={formData.communityAddressDTO.countryId || ""}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  >
//                    <option value="">Select Country</option>
//                    {countryData?.map((country) => (
//                      <option key={country.countryId} value={country.countryid}>
//                        {country.countryname}
//                      </option>
//                    ))}
//                  </select>
//                  {errors.communityCountryId && <p className="text-white text-sm mt-1">{errors.communityCountryId}</p>}
//                </div>

//                {/* Community State */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="communityStateId" className="block mb-1 text-white">State *</label>
//                  <select
//                    id="communityStateId"
//                    name="communityAddressDTO.stateId"
//                    value={formData.communityAddressDTO.stateId || ""}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  >
//                    <option value="">Select State</option>
//                    {stateData
//                      .filter((state) => state.countryid === parseInt(selectedCommunityCountryId))
//                      .map((state) => (
//                        <option key={state.stateid} value={state.stateid}>
//                          {state.statename}
//                        </option>
//                      ))}
//                  </select>
//                  {errors.communityStateId && <p className="text-white text-sm mt-1">{errors.communityStateId}</p>}
//                </div>

//                {/* Community City */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="communityCity" className="block mb-1 text-white">City *</label>
//                  <input
//                    id="communityCity"
//                    type="text"
//                    placeholder="City"
//                    name="communityAddressDTO.city"
//                    value={formData.communityAddressDTO.city}
//                    onChange={handleChange}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                    maxLength={100}
//                  />
//                  {errors.communityCity && <p className="text-white text-sm mt-1">{errors.communityCity}</p>}
//                </div>

//                {/* Community Zip Code */}
//                <div className="w-full sm:w-[calc(50%-20px)]">
//                  <label htmlFor="communityZipCode" className="block mb-1 text-white">Community Zip Code *</label>
//                  <input
//                    type="text"
//                    placeholder="Community Zip Code"
//                    name="communityAddressDTO.zipCode"
//                    id="communityZipCode"
//                    onChange={handleChange}
//                    value={formData.communityAddressDTO.zipCode}
//                    pattern="\d*"
//                    inputMode="numeric"
//                    maxLength={10}
//                    onKeyPress={handleKeyPress}
//                    className="w-full rounded-lg block border-2 border-gray-300 border-opacity-30 outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out border-none bg-white focus:border-blue-800 focus:shadow-sm"
//                  />
//                  {errors.communityZipCode && <p className="text-white text-sm mt-1">{errors.communityZipCode}</p>}
//                </div>

//                {/* Insurance and License Section */}
//                <div className="w-full flex flex-col gap-4">
//                  {/* Insurance Radio */}
//                  <div className="w-full">
//                    <label className="block mb-1 text-white">Do you have Insurance? *</label>
//                    <div className="flex gap-5">
//                      <label className="text-xl bg-transparent leading-tight grid grid-cols-[1em_auto] gap-2 text-white cursor-pointer">
//                        <input
//                          type="radio"
//                          name="insurance"
//                          value="yes"
//                          onChange={handleInsuranceChange}
//                          className="appearance-none bg-white w-4 h-4 border-2 border-gray-300 rounded-full checked:bg-blue-800 checked:border-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2"
//                        />
//                        Yes
//                      </label>
//                      <label className="text-xl bg-transparent leading-tight grid grid-cols-[1em_auto] gap-2 text-white cursor-pointer">
//                        <input
//                          type="radio"
//                          name="insurance"
//                          value="no"
//                          onChange={handleInsuranceChange}
//                          className="appearance-none bg-white w-4 h-4 border-2 border-gray-300 rounded-full checked:bg-blue-800 checked:border-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2"
//                        />
//                        No
//                      </label>
//                    </div>
//                  </div>

//                  {/* Insurance File Upload */}
//                  {showInsuranceDetails && (
//                    <div className="w-full pb-5">
//                      <div className="w-[85%] mx-auto my-5 flex flex-col text-white">
//                        <h2 className="text-xl font-bold">Attach Insurance Details</h2>
//                      </div>
//                      <div className="text-center w-[60%] mx-auto flex items-center justify-center border-2 border-dashed border-white rounded-lg p-8">
//                        <label htmlFor="insuranceFileInput" className="cursor-pointer">
//                          <div className={selectedInsuranceFile ? "upload-pre" : "pre"}>
//                            {selectedInsuranceFile ? (
//                              <div className="file-upload">
//                                <p className="text-white">{selectedInsuranceFile.name}</p>
//                              </div>
//                            ) : (
//                              <>
//                                <AiOutlineCloudUpload className="text-[70px] text-white mx-auto mb-4" />
//                                <p className="text-2xl font-extrabold text-white mb-2">Click to Upload</p>
//                                <p className="text-2xl font-extrabold text-white">Up to total of 3MB</p>
//                              </>
//                            )}
//                          </div>
//                          <input
//                            type="file"
//                            id="insuranceFileInput"
//                            onChange={(e) => handleFileChange(e, "insurance")}
//                            accept=".pdf,.doc,.docx"
//                            className="hidden"
//                          />
//                        </label>
//                      </div>
//                    </div>
//                  )}

//                  {/* License Radio */}
//                  <div className="w-full">
//                    <label className="block mb-1 text-white">Do you have a License? *</label>
//                    <div className="flex gap-5">
//                      <label className="text-xl bg-transparent leading-tight grid grid-cols-[1em_auto] gap-2 text-white cursor-pointer">
//                        <input
//                          type="radio"
//                          name="license"
//                          value="yes"
//                          onChange={handleLicenseChange}
//                          className="appearance-none bg-white w-4 h-4 border-2 border-gray-300 rounded-full checked:bg-blue-800 checked:border-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2"
//                        />
//                        Yes
//                      </label>
//                      <label className="text-xl bg-transparent leading-tight grid grid-cols-[1em_auto] gap-2 text-white cursor-pointer">
//                        <input
//                          type="radio"
//                          name="license"
//                          value="no"
//                          onChange={handleLicenseChange}
//                          className="appearance-none bg-white w-4 h-4 border-2 border-gray-300 rounded-full checked:bg-blue-800 checked:border-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-800 focus:ring-offset-2"
//                        />
//                        No
//                      </label>
//                    </div>
//                  </div>

//                  {/* License File Upload */}
//                  {showLicenseDetails && (
//                    <div className="w-full pb-5">
//                      <div className="w-[85%] mx-auto my-5 flex flex-col text-white">
//                        <h2 className="text-xl font-bold">Attach License Details</h2>
//                      </div>
//                      <div className="text-center w-[60%] mx-auto flex items-center justify-center border-2 border-dashed border-white rounded-lg p-8">
//                        <label htmlFor="licenseFileInput" className="cursor-pointer">
//                          <div className={selectedLicenseFile ? "upload-pre" : "pre"}>
//                            {selectedLicenseFile ? (
//                              <div className="file-upload">
//                                <p className="text-white">{selectedLicenseFile.name}</p>
//                              </div>
//                            ) : (
//                              <>
//                                <AiOutlineCloudUpload className="text-[70px] text-white mx-auto mb-4" />
//                                <p className="text-2xl font-extrabold text-white mb-2">Click to Upload</p>
//                                <p className="text-2xl font-extrabold text-white">Up to total of 3MB</p>
//                              </>
//                            )}
//                          </div>
//                          <input
//                            type="file"
//                            id="licenseFileInput"
//                            onChange={(e) => handleFileChange(e, "license")}
//                            accept=".pdf,.doc,.docx"
//                            className="hidden"
//                          />
//                        </label>
//                      </div>
//                    </div>
//                  )}
//                </div>
//              </div>

//              {/* Submit Buttons */}
//              <div className="flex justify-end gap-5 mt-5 pr-10">
//                <button
//                  className="text-center bg-blue-800 text-white text-lg font-bold cursor-pointer border border-white rounded-md py-4 px-8 transition-colors hover:border-white"
//                  type="button"
//                  onClick={handleCancel}
//                >
//                  Cancel
//                </button>
//                <button
//                  className="text-center bg-white text-blue-800 text-lg font-bold cursor-pointer border-none rounded-md py-4 px-8 transition-colors hover:bg-gray-100"
//                  type="submit"
//                >
//                  Submit
//                </button>
//              </div>
//            </form>
//          </div>
//        </div>
//      )}
//      <div className="hoa-footer-import">
//        <HoaFooter />
//      </div>
//    </>
//  );
//};

//export default HoaVendorOnBoard;

import React, { useState, useEffect } from "react";
import HoaNavbar from "../HoaNavbar/HoaNavbar";
import HoaFooter from "../HoaFooter/HoaFooter";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faFileAlt, faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../apiConfig";
import LoadingComman from "../Loading/LoadingCommon";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const HoaVendorOnBoard = () => {
    const history = useHistory();

    // Consolidated useEffect for fetching countries and business types
    useEffect(() => {
        // Fetch countries
        axios
            .get(`${API_URL}/public/country/getAll`)
            .then((response) => {
                setCountryData(response.data);
            })
            .catch((error) => {
                console.error("Error fetching countries:", error);
            });

        // Fetch business types
        axios
            .get(`${API_URL}/public/servicetype/getAll`)
            .then((response) => {
                setBusinessTypes(response.data);
            })
            .catch((error) => {
                console.error("Error fetching business types:", error);
            });

        // Fetch states
        axios
            .get(`${API_URL}/public/state/getAll`)
            .then((response) => {
                setStateData(response.data);
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    }, []);

    const getCurrentDate = () => {
        const date = new Date();
        return date.toISOString();
    };

    const INITIAL_FORM_STATE = {
        communityAddressDTO: {
            address: "",
            city: "",
            stateId: null,
            addressId: 0,
            countryId: null,
            zipCode: "",
            activeStatus: true,
        },
        companyAddressDTO: {
            address: "",
            city: "",
            stateId: 0,
            addressId: 0,
            countryId: 0,
            zipCode: "",
            activeStatus: true,
        },
        vendorDTO: {
            activeStatus: true,
            companyName: "",
            name: "",
            emailId: "",
            phone: "",
            businessEmailId: "",
            businessPhone: "",
            taxId: "",
            comments: "",
            isAcceptCcPayment: null,
            licenseExpiryDate: "",
            licenceNumber: "",
            insuranceNumber: "",
            isPropertyNeeded: true,
            createdById: null,
            modifiedById: null,
            createdDate: getCurrentDate(),
            modifiedDate: getCurrentDate(),
            serviceTypeId: 0,
            communityAddressId: 0,
            companyAddressId: 0,
            vendorId: 0,
            zipCode: "",
            vendorCode: "",
            insuranceDocument: null,
            licenceDocument: null,
        },
    };

    const [formData, setFormData] = useState(INITIAL_FORM_STATE);
    const [selectedCountryId, setSelectedCountryId] = useState("");
    const [selectedCommunityCountryId, setSelectedCommunityCountryId] = useState("");
    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData] = useState([]);
    const [showInsuranceDetails, setShowInsuranceDetails] = useState(false);
    const [showLicenseDetails, setShowLicenseDetails] = useState(false);
    const [loadingComman, setLoadingComman] = useState(false);
    const [errors, setErrors] = useState({});
    const [businessTypes, setBusinessTypes] = useState([]);
    const [needAccess, setNeedAccess] = useState("");
    const [workingForCommunity, setWorkingForCommunity] = useState("");
    const [selectedInsuranceFile, setSelectedInsuranceFile] = useState(null);
    const [selectedLicenseFile, setSelectedLicenseFile] = useState(null);

    const resetFormState = () => {
        setFormData(INITIAL_FORM_STATE);
        setErrors({});
        setShowLicenseDetails(false);
        setShowInsuranceDetails(false);
        setNeedAccess("");
        setWorkingForCommunity("");
        setSelectedInsuranceFile(null);
        setSelectedLicenseFile(null);
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevFormData) => {
            const updatedFormData = { ...prevFormData };

            if (name === "companyAddressDTO.countryId") {
                setSelectedCountryId(parseInt(value, 10) || "");
            }
            if (name === "communityAddressDTO.countryId") {
                setSelectedCommunityCountryId(parseInt(value, 10) || "");
            }

            const nameParts = name.split(".");
            if (nameParts.length > 1) {
                const [category, key] = nameParts;

                const numericFields = {
                    companyAddressDTO: ["countryId", "stateId"],
                    communityAddressDTO: ["countryId", "stateId"],
                    vendorDTO: ["serviceTypeId"],
                };

                const shouldConvertToNumber = numericFields[category]?.includes(key);
                const updatedValue = shouldConvertToNumber
                    ? value === "" ? "" : parseInt(value, 10)
                    : type === "checkbox"
                        ? checked
                        : value;

                updatedFormData[category] = {
                    ...updatedFormData[category],
                    [key]: updatedValue,
                };
            }

            return updatedFormData;
        });

        // Clear errors when user starts typing
        setErrors(prevErrors => {
            const updatedErrors = { ...prevErrors };
            const errorKey = name.split('.').pop();
            if (updatedErrors[errorKey]) {
                delete updatedErrors[errorKey];
            }
            return updatedErrors;
        });
    };

    const handleAcceptCCPaymentChange = (event) => {
        const { value } = event.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            vendorDTO: {
                ...prevFormData.vendorDTO,
                isAcceptCcPayment: value === "true",
            },
        }));

        // Clear error
        setErrors(prevErrors => ({
            ...prevErrors,
            isAcceptCcPayment: ""
        }));
    };

    const handleInsuranceChange = (e) => {
        setShowInsuranceDetails(e.target.value === "yes");
    };

    const handleLicenseChange = (e) => {
        setShowLicenseDetails(e.target.value === "yes");
    };

    const handleAccessChange = (e) => {
        setNeedAccess(e.target.value);
    };

    const handleCommunityWorkChange = (e) => {
        setWorkingForCommunity(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    const handlePhoneNumberChange = (name, value) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            vendorDTO: {
                ...prevFormData.vendorDTO,
                [name]: value,
            },
        }));

        // Clear error
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: value ? "" : prevErrors[name]
        }));
    };

    const validateForm = async () => {
        let isValid = true;
        const newErrors = {};

        const isEmpty = (value) =>
            value === null || value === undefined || (typeof value === "string" && !value.trim());

        const isValidPhoneNumber = (phoneNumber) => phoneNumber && phoneNumber.length >= 10;

        const isValidEmail = (email) =>
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

        const isValidLicenseNumber = (licenseNumber) => /^DL14\s\d{11}$/.test(licenseNumber);

        if (isEmpty(formData.vendorDTO.companyName)) {
            newErrors.companyName = "Please provide your company name.";
            isValid = false;
        }
        if (formData.vendorDTO.isAcceptCcPayment === null) {
            newErrors.isAcceptCcPayment = "Please specify if you accept CC payment.";
            isValid = false;
        }
        if (isEmpty(formData.vendorDTO.name)) {
            newErrors.name = "Please provide your name.";
            isValid = false;
        }
        if (!isValidPhoneNumber(formData.vendorDTO.businessPhone)) {
            newErrors.businessPhone = "Please enter a valid business phone number.";
            isValid = false;
        }
        if (!isValidPhoneNumber(formData.vendorDTO.phone)) {
            newErrors.phone = "Please enter a valid phone number.";
            isValid = false;
        }
        if (isEmpty(formData.vendorDTO.businessEmailId) || !isValidEmail(formData.vendorDTO.businessEmailId)) {
            newErrors.businessEmailId = "Please provide a valid email address.";
            isValid = false;
        } else {
            const isEmailAvailable = await handleEmailCheck(formData.vendorDTO.businessEmailId);
            if (isEmailAvailable) {
                newErrors.businessEmailId = "Email is already taken.";
                isValid = false;
            }
        }
        if (isEmpty(formData.vendorDTO.emailId) || !isValidEmail(formData.vendorDTO.emailId)) {
            newErrors.emailId = "Please provide a valid email address.";
            isValid = false;
        } else {
            const isEmailAvailable = await handleEmailCheck(formData.vendorDTO.emailId);
            if (isEmailAvailable) {
                newErrors.emailId = "Email is already taken.";
                isValid = false;
            }
        }
        if (formData.vendorDTO.businessEmailId && formData.vendorDTO.emailId && formData.vendorDTO.businessEmailId === formData.vendorDTO.emailId) {
            newErrors.emailId = "Business and personal email IDs cannot be the same.";
            isValid = false;
        }
        if (isEmpty(formData.vendorDTO.taxId)) {
            newErrors.taxId = "Please provide your tax ID.";
            isValid = false;
        } else if (!/^\d{10}$/.test(formData.vendorDTO.taxId)) {
            newErrors.taxId = "Tax ID must be exactly 10 digits.";
            isValid = false;
        }
        if (isEmpty(formData.vendorDTO.comments)) {
            newErrors.comments = "Please provide your comments.";
            isValid = false;
        }
        if (isEmpty(formData.vendorDTO.licenseExpiryDate)) {
            newErrors.licenseExpiryDate = "Please provide the license expiry date.";
            isValid = false;
        }
        if (isEmpty(formData.vendorDTO.licenceNumber) || !isValidLicenseNumber(formData.vendorDTO.licenceNumber)) {
            newErrors.licenceNumber = "License number must be in the format DL14 20110012345.";
            isValid = false;
        }
        if (isEmpty(formData.vendorDTO.insuranceNumber)) {
            newErrors.insuranceNumber = "Please provide the insurance number.";
            isValid = false;
        }
        if (formData.vendorDTO.serviceTypeId === 0) {
            newErrors.serviceTypeId = "Please select a service type.";
            isValid = false;
        }
        if (isEmpty(formData.companyAddressDTO.address)) {
            newErrors.companyAddress = "Please provide the company address.";
            isValid = false;
        }
        if (isEmpty(formData.communityAddressDTO.address)) {
            newErrors.communityAddress = "Please provide the community address.";
            isValid = false;
        }
        if (!formData.companyAddressDTO.countryId) {
            newErrors.companyCountryId = "Please select a company country.";
            isValid = false;
        }
        if (!formData.communityAddressDTO.countryId) {
            newErrors.communityCountryId = "Please select a community country.";
            isValid = false;
        }
        if (!formData.companyAddressDTO.stateId) {
            newErrors.companyStateId = "Please select a company state.";
            isValid = false;
        }
        if (!formData.communityAddressDTO.stateId) {
            newErrors.communityStateId = "Please select a community state.";
            isValid = false;
        }
        if (isEmpty(formData.companyAddressDTO.city)) {
            newErrors.companyCity = "Please provide the company city.";
            isValid = false;
        }
        if (isEmpty(formData.communityAddressDTO.city)) {
            newErrors.communityCity = "Please provide the community city.";
            isValid = false;
        }
        if (isEmpty(formData.companyAddressDTO.zipCode)) {
            newErrors.companyZipCode = "Please provide the company zip code.";
            isValid = false;
        }
        if (isEmpty(formData.vendorDTO.zipCode)) {
            newErrors.vendorZipCode = "Please provide the vendor zip code.";
            isValid = false;
        }
        if (isEmpty(formData.communityAddressDTO.zipCode)) {
            newErrors.communityZipCode = "Please provide the community zip code.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;
        const [object, key] = name.split(".");

        if (key === "licenceNumber") {
            if (!validateLicenceNumber(value)) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    licenceNumber: "License number must be in the format DL14 20110012345.",
                }));
            } else {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    licenceNumber: "",
                }));
            }
        }
    };

    const handleFileChange = (event, type) => {
        if (type === "insurance") {
            setSelectedInsuranceFile(event.target.files[0]);
        } else if (type === "license") {
            setSelectedLicenseFile(event.target.files[0]);
        }
    };

    const displayValue = (value) => {
        return value === "" || value === 0 ? "" : value;
    };

    const handleEmailCheck = async (email) => {
        try {
            const response = await axios.get(`${API_URL}/user/check/email?emailId=${email}`);
            return response.status !== 200; // Return false if email exists (200), true if available
        } catch (error) {
            console.error("Error checking email:", error);
            return true; // Assume available on error to avoid blocking submission
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = await validateForm();

        if (isValid) {
            setLoadingComman(true);
            let insuranceDocUrl = null;
            let licenseDocUrl = null;

            try {
                if (selectedInsuranceFile) {
                    const insuranceFormData = new FormData();
                    insuranceFormData.append("file", selectedInsuranceFile);
                    const insuranceUploadResponse = await axios.post(
                        `${API_URL}/public/vendor/insuranceUpload`,
                        insuranceFormData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );
                    insuranceDocUrl = insuranceUploadResponse.data;
                }

                if (selectedLicenseFile) {
                    const licenseFormData = new FormData();
                    licenseFormData.append("file", selectedLicenseFile);
                    const licenseUploadResponse = await axios.post(
                        `${API_URL}/public/vendor/licenceUpload`,
                        licenseFormData,
                        { headers: { "Content-Type": "multipart/form-data" } }
                    );
                    licenseDocUrl = licenseUploadResponse.data;
                }

                const updatedFormData = {
                    ...formData,
                    vendorDTO: {
                        ...formData.vendorDTO,
                        insuranceDocument: insuranceDocUrl,
                        licenceDocument: licenseDocUrl,
                    },
                };

                const response = await axios.post(`${API_URL}/public/vendor/add`, updatedFormData);
                alert("Form submitted successfully!");
                resetFormState();
                history.push("/"); // Redirect to home or another page
            } catch (error) {
                console.error("Error submitting form:", error.response?.data || error.message);
                alert("Failed to submit form. Please try again or contact support.");
            } finally {
                setLoadingComman(false);
            }
        } else {
            alert("Please fill in all required fields correctly.");
        }
    };

    const handleCancel = () => {
        resetFormState();
        history.push("/"); // Redirect instead of reloading
    };

    const validateLicenceNumber = (licenceNumber) => {
        const regex = /^DL14\s\d{11}$/;
        return regex.test(licenceNumber);
    };

    return (
        <>
            <div className="fixed top-0 w-full z-50">
                <HoaNavbar />
            </div>
            {loadingComman && <LoadingComman />}
            {!loadingComman && (
                <div className="mt-[70px] min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-4">
                    <div className="max-w-7xl mx-auto">
                        <div className="bg-gradient-to-br from-blue-800 to-blue-900 text-white shadow-2xl rounded-2xl overflow-hidden">
                            {/* Header Section */}
                            <div className="px-6 sm:px-8 lg:px-12 py-8 border-b border-blue-700/30">
                                <div className="flex items-center gap-4 mb-6">
                                    <div className="p-3 bg-white/10 rounded-xl backdrop-blur-sm">
                                        <FontAwesomeIcon icon={faBuilding} className="w-6 h-6 text-white" />
                                    </div>
                                    <div>
                                        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">Vendor Registration</h1>
                                        <p className="text-blue-100 text-lg">Join our vendor network by providing your business information</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2 text-sm text-blue-200">
                                    <span className="w-2 h-2 bg-red-400 rounded-full animate-pulse"></span>
                                    Required fields are marked with an asterisk (*)
                                </div>
                            </div>

                            {/* Form Section */}
                            <div className="px-6 sm:px-8 lg:px-12 py-8">
                                <form onSubmit={handleSubmit} className="space-y-8">
                                    {/* Company Information Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <div className="flex items-center gap-3 mb-6">
                                            <FontAwesomeIcon icon={faBuilding} className="w-5 h-5 text-blue-200" />
                                            <h3 className="text-xl font-semibold text-white">Company Information</h3>
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div>
                                                <label htmlFor="companyName" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Company Name *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="vendorDTO.companyName"
                                                    id="companyName"
                                                    placeholder="Enter company name"
                                                    value={formData.vendorDTO.companyName}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={100}
                                                />
                                                {errors.companyName && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.companyName}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="serviceTypeId" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Type of Business *
                                                </label>
                                                <select
                                                    name="vendorDTO.serviceTypeId"
                                                    id="serviceTypeId"
                                                    value={formData.vendorDTO.serviceTypeId}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
                                                >
                                                    <option value="">Select Business Type</option>
                                                    {businessTypes.map((type) => (
                                                        <option key={type.id} value={type.id}>
                                                            {type.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.serviceTypeId && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.serviceTypeId}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="taxId" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Tax ID *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="vendorDTO.taxId"
                                                    id="taxId"
                                                    placeholder="Enter 10-digit tax ID"
                                                    value={formData.vendorDTO.taxId}
                                                    onChange={handleChange}
                                                    maxLength={10}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    onKeyPress={handleKeyPress}
                                                />
                                                {errors.taxId && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.taxId}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label className="block mb-3 text-sm font-medium text-blue-100">
                                                    Do you accept credit card payments? *
                                                </label>
                                                <div className="flex gap-6">
                                                    <label className="flex items-center gap-2 cursor-pointer">
                                                        <input
                                                            type="radio"
                                                            name="vendorDTO.isAcceptCcPayment"
                                                            value={true}
                                                            checked={formData.vendorDTO.isAcceptCcPayment === true}
                                                            onChange={handleAcceptCCPaymentChange}
                                                            className="w-4 h-4 text-blue-600 bg-white border-2 border-gray-300 focus:ring-blue-500 focus:ring-2 transition-all duration-200"
                                                        />
                                                        <span className="text-blue-100">Yes</span>
                                                    </label>
                                                    <label className="flex items-center gap-2 cursor-pointer">
                                                        <input
                                                            type="radio"
                                                            name="vendorDTO.isAcceptCcPayment"
                                                            value={false}
                                                            checked={formData.vendorDTO.isAcceptCcPayment === false}
                                                            onChange={handleAcceptCCPaymentChange}
                                                            className="w-4 h-4 text-blue-600 bg-white border-2 border-gray-300 focus:ring-blue-500 focus:ring-2 transition-all duration-200"
                                                        />
                                                        <span className="text-blue-100">No</span>
                                                    </label>
                                                </div>
                                                {errors.isAcceptCcPayment && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.isAcceptCcPayment}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Business Contact Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <h3 className="text-xl font-semibold mb-6 text-white">Business Contact Information</h3>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                            <div>
                                                <label htmlFor="businessPhone" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Business Phone Number *
                                                </label>
                                                <PhoneInput
                                                    placeholder="Enter business phone number"
                                                    value={formData.vendorDTO.businessPhone}
                                                    onChange={(value) => handlePhoneNumberChange("businessPhone", value)}
                                                    country="us"
                                                    containerClass="w-full"
                                                    inputClass="phone-input-custom"
                                                    inputStyle={{
                                                        width: '100%',
                                                        height: '48px',
                                                        fontSize: '16px',
                                                        borderRadius: '12px',
                                                        border: '1px solid #d1d5db',
                                                        outline: 'none',
                                                        backgroundColor: 'white',
                                                        color: '#111827',
                                                        paddingLeft: '60px'
                                                    }}
                                                    buttonStyle={{
                                                        borderRadius: '12px 0 0 12px',
                                                        border: '1px solid #d1d5db',
                                                        backgroundColor: 'white'
                                                    }}
                                                />
                                                {errors.businessPhone && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.businessPhone}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="businessEmailId" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Business Email Address *
                                                </label>
                                                <input
                                                    type="email"
                                                    name="vendorDTO.businessEmailId"
                                                    id="businessEmailId"
                                                    placeholder="Enter business email"
                                                    value={formData.vendorDTO.businessEmailId}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={100}
                                                />
                                                {errors.businessEmailId && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.businessEmailId}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Company Address Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <h3 className="text-xl font-semibold mb-6 text-white">Company Address</h3>
                                        <div className="grid grid-cols-1 gap-6">
                                            <div>
                                                <label htmlFor="address" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Company Address *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="companyAddressDTO.address"
                                                    id="address"
                                                    placeholder="Enter complete company address"
                                                    value={formData.companyAddressDTO.address}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={100}
                                                />
                                                {errors.companyAddress && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.companyAddress}
                                                    </p>
                                                )}
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                                <div>
                                                    <label htmlFor="companycity" className="block mb-2 text-sm font-medium text-blue-100">
                                                        City *
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="companyAddressDTO.city"
                                                        id="companycity"
                                                        placeholder="Enter city"
                                                        value={formData.companyAddressDTO.city}
                                                        onChange={handleChange}
                                                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                        maxLength={100}
                                                    />
                                                    {errors.companyCity && (
                                                        <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                            {errors.companyCity}
                                                        </p>
                                                    )}
                                                </div>

                                                <div>
                                                    <label htmlFor="countryId" className="block mb-2 text-sm font-medium text-blue-100">
                                                        Country *
                                                    </label>
                                                    <select
                                                        id="countryId"
                                                        name="companyAddressDTO.countryId"
                                                        value={formData.companyAddressDTO.countryId || ""}
                                                        onChange={handleChange}
                                                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
                                                    >
                                                        <option value="">Select Country</option>
                                                        {countryData?.map((country) => (
                                                            <option key={country.countryId} value={country.countryid}>
                                                                {country.countryname}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.companyCountryId && (
                                                        <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                            {errors.companyCountryId}
                                                        </p>
                                                    )}
                                                </div>

                                                <div>
                                                    <label htmlFor="stateId" className="block mb-2 text-sm font-medium text-blue-100">
                                                        State *
                                                    </label>
                                                    <select
                                                        id="stateId"
                                                        name="companyAddressDTO.stateId"
                                                        value={formData.companyAddressDTO.stateId || ""}
                                                        onChange={handleChange}
                                                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
                                                    >
                                                        <option value="">Select State</option>
                                                        {stateData
                                                            .filter((state) => state.countryid === parseInt(selectedCountryId))
                                                            .map((state) => (
                                                                <option key={state.stateid} value={state.stateid}>
                                                                    {state.statename}
                                                                </option>
                                                            ))}
                                                    </select>
                                                    {errors.companyStateId && (
                                                        <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                            {errors.companyStateId}
                                                        </p>
                                                    )}
                                                </div>

                                                <div>
                                                    <label htmlFor="companyZipCode" className="block mb-2 text-sm font-medium text-blue-100">
                                                        Zip Code *
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="companyAddressDTO.zipCode"
                                                        id="companyZipCode"
                                                        placeholder="Enter zip code"
                                                        value={formData.companyAddressDTO.zipCode}
                                                        onChange={handleChange}
                                                        pattern="\d*"
                                                        inputMode="numeric"
                                                        maxLength={10}
                                                        onKeyPress={handleKeyPress}
                                                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    />
                                                    {errors.companyZipCode && (
                                                        <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                            {errors.companyZipCode}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Personal Contact Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <h3 className="text-xl font-semibold mb-4 text-white">Personal Contact Information</h3>
                                        <p className="text-blue-100 mb-6">Provide your personal contact details for community work</p>
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                            <div>
                                                <label htmlFor="name" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Full Name *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="vendorDTO.name"
                                                    id="name"
                                                    placeholder="Enter your full name"
                                                    value={formData.vendorDTO.name}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={50}
                                                />
                                                {errors.name && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.name}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="phone" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Personal Phone Number *
                                                </label>
                                                <PhoneInput
                                                    placeholder="Enter phone number"
                                                    value={formData.vendorDTO.phone}
                                                    onChange={(value) => handlePhoneNumberChange("phone", value)}
                                                    country="us"
                                                    containerClass="w-full"
                                                    inputClass="phone-input-custom"
                                                    inputStyle={{
                                                        width: '100%',
                                                        height: '48px',
                                                        fontSize: '16px',
                                                        borderRadius: '12px',
                                                        border: '1px solid #d1d5db',
                                                        outline: 'none',
                                                        backgroundColor: 'white',
                                                        color: '#111827',
                                                        paddingLeft: '60px'
                                                    }}
                                                    buttonStyle={{
                                                        borderRadius: '12px 0 0 12px',
                                                        border: '1px solid #d1d5db',
                                                        backgroundColor: 'white'
                                                    }}
                                                />
                                                {errors.phone && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.phone}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="emailId" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Personal Email Address *
                                                </label>
                                                <input
                                                    type="email"
                                                    name="vendorDTO.emailId"
                                                    id="emailId"
                                                    placeholder="Enter personal email"
                                                    value={formData.vendorDTO.emailId}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={100}
                                                />
                                                {errors.emailId && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.emailId}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="vendorZipCode" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Personal Zip Code *
                                                </label>
                                                <input
                                                    name="vendorDTO.zipCode"
                                                    id="vendorZipCode"
                                                    placeholder="Enter zip code"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={formData.vendorDTO.zipCode}
                                                    pattern="\d*"
                                                    inputMode="numeric"
                                                    maxLength={10}
                                                    onKeyPress={handleKeyPress}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                />
                                                {errors.vendorZipCode && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.vendorZipCode}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Community Address Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <h3 className="text-xl font-semibold mb-6 text-white">Community Address</h3>
                                        <div className="grid grid-cols-1 gap-6">
                                            <div>
                                                <label htmlFor="communityAddress" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Community Address *
                                                </label>
                                                <input
                                                    type="text"
                                                    id="communityAddress"
                                                    placeholder="Enter community address"
                                                    name="communityAddressDTO.address"
                                                    value={formData.communityAddressDTO.address}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    maxLength={200}
                                                />
                                                {errors.communityAddress && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.communityAddress}
                                                    </p>
                                                )}
                                            </div>

                                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                                <div>
                                                    <label htmlFor="communityCity" className="block mb-2 text-sm font-medium text-blue-100">
                                                        City *
                                                    </label>
                                                    <input
                                                        id="communityCity"
                                                        type="text"
                                                        placeholder="Enter city"
                                                        name="communityAddressDTO.city"
                                                        value={formData.communityAddressDTO.city}
                                                        onChange={handleChange}
                                                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                        maxLength={100}
                                                    />
                                                    {errors.communityCity && (
                                                        <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                            {errors.communityCity}
                                                        </p>
                                                    )}
                                                </div>

                                                <div>
                                                    <label htmlFor="communityCountryId" className="block mb-2 text-sm font-medium text-blue-100">
                                                        Country *
                                                    </label>
                                                    <select
                                                        id="communityCountryId"
                                                        name="communityAddressDTO.countryId"
                                                        value={formData.communityAddressDTO.countryId || ""}
                                                        onChange={handleChange}
                                                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
                                                    >
                                                        <option value="">Select Country</option>
                                                        {countryData?.map((country) => (
                                                            <option key={country.countryId} value={country.countryid}>
                                                                {country.countryname}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {errors.communityCountryId && (
                                                        <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                            {errors.communityCountryId}
                                                        </p>
                                                    )}
                                                </div>

                                                <div>
                                                    <label htmlFor="communityStateId" className="block mb-2 text-sm font-medium text-blue-100">
                                                        State *
                                                    </label>
                                                    <select
                                                        id="communityStateId"
                                                        name="communityAddressDTO.stateId"
                                                        value={formData.communityAddressDTO.stateId || ""}
                                                        onChange={handleChange}
                                                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm appearance-none"
                                                    >
                                                        <option value="">Select State</option>
                                                        {stateData
                                                            .filter((state) => state.countryid === parseInt(selectedCommunityCountryId))
                                                            .map((state) => (
                                                                <option key={state.stateid} value={state.stateid}>
                                                                    {state.statename}
                                                                </option>
                                                            ))}
                                                    </select>
                                                    {errors.communityStateId && (
                                                        <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                            {errors.communityStateId}
                                                        </p>
                                                    )}
                                                </div>

                                                <div>
                                                    <label htmlFor="communityZipCode" className="block mb-2 text-sm font-medium text-blue-100">
                                                        Zip Code *
                                                    </label>
                                                    <input
                                                        type="text"
                                                        placeholder="Enter zip code"
                                                        name="communityAddressDTO.zipCode"
                                                        id="communityZipCode"
                                                        onChange={handleChange}
                                                        value={formData.communityAddressDTO.zipCode}
                                                        pattern="\d*"
                                                        inputMode="numeric"
                                                        maxLength={10}
                                                        onKeyPress={handleKeyPress}
                                                        className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    />
                                                    {errors.communityZipCode && (
                                                        <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                            {errors.communityZipCode}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Licensing & Insurance Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <div className="flex items-center gap-3 mb-6">
                                            <FontAwesomeIcon icon={faShieldAlt} className="w-5 h-5 text-blue-200" />
                                            <h3 className="text-xl font-semibold text-white">Licensing & Insurance Information</h3>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                                            <div>
                                                <label htmlFor="insuranceNumber" className="block mb-2 text-sm font-medium text-blue-100">
                                                    Insurance Number *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="vendorDTO.insuranceNumber"
                                                    id="insuranceNumber"
                                                    placeholder="Enter insurance number"
                                                    value={formData.vendorDTO.insuranceNumber}
                                                    onChange={handleChange}
                                                    maxLength={50}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                />
                                                {errors.insuranceNumber && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.insuranceNumber}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="licenceNumber" className="block mb-2 text-sm font-medium text-blue-100">
                                                    License Number *
                                                </label>
                                                <input
                                                    type="text"
                                                    name="vendorDTO.licenceNumber"
                                                    id="licenceNumber"
                                                    placeholder="e.g., DL14 20110012345"
                                                    value={formData.vendorDTO.licenceNumber}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    maxLength={50}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                />
                                                {errors.licenceNumber && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.licenceNumber}
                                                    </p>
                                                )}
                                            </div>

                                            <div>
                                                <label htmlFor="licenseExpiryDate" className="block mb-2 text-sm font-medium text-blue-100">
                                                    License Expiry Date *
                                                </label>
                                                <input
                                                    type="date"
                                                    name="vendorDTO.licenseExpiryDate"
                                                    id="licenseExpiryDate"
                                                    value={formData.vendorDTO.licenseExpiryDate}
                                                    onChange={handleChange}
                                                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm"
                                                    min={new Date().toISOString().split("T")[0]}
                                                />
                                                {errors.licenseExpiryDate && (
                                                    <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                        {errors.licenseExpiryDate}
                                                    </p>
                                                )}
                                            </div>
                                        </div>

                                        {/* Insurance Documents */}
                                        <div className="space-y-6">
                                            <div>
                                                <label className="block mb-3 text-sm font-medium text-blue-100">
                                                    Do you have insurance documentation? *
                                                </label>
                                                <div className="flex gap-6">
                                                    <label className="flex items-center gap-2 cursor-pointer">
                                                        <input
                                                            type="radio"
                                                            name="insurance"
                                                            value="yes"
                                                            onChange={handleInsuranceChange}
                                                            className="w-4 h-4 text-blue-600 bg-white border-2 border-gray-300 focus:ring-blue-500 focus:ring-2 transition-all duration-200"
                                                        />
                                                        <span className="text-blue-100">Yes</span>
                                                    </label>
                                                    <label className="flex items-center gap-2 cursor-pointer">
                                                        <input
                                                            type="radio"
                                                            name="insurance"
                                                            value="no"
                                                            onChange={handleInsuranceChange}
                                                            className="w-4 h-4 text-blue-600 bg-white border-2 border-gray-300 focus:ring-blue-500 focus:ring-2 transition-all duration-200"
                                                        />
                                                        <span className="text-blue-100">No</span>
                                                    </label>
                                                </div>
                                            </div>

                                            {showInsuranceDetails && (
                                                <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                                                    <div className="flex items-center gap-3 mb-4">
                                                        <FontAwesomeIcon icon={faFileAlt} className="w-4 h-4 text-blue-200" />
                                                        <h4 className="text-lg font-semibold text-white">Upload Insurance Document</h4>
                                                    </div>
                                                    <div className="border-2 border-dashed border-white/30 rounded-xl p-8 text-center hover:border-white/50 transition-colors duration-200">
                                                        <label htmlFor="insuranceFileInput" className="cursor-pointer block">
                                                            {selectedInsuranceFile ? (
                                                                <div className="space-y-2">
                                                                    <div className="p-3 bg-green-500/20 rounded-lg inline-block">
                                                                        <FontAwesomeIcon icon={faFileAlt} className="w-8 h-8 text-green-300" />
                                                                    </div>
                                                                    <p className="text-white font-medium">{selectedInsuranceFile.name}</p>
                                                                    <p className="text-blue-200 text-sm">Click to change file</p>
                                                                </div>
                                                            ) : (
                                                                <div className="space-y-4">
                                                                    <AiOutlineCloudUpload className="w-16 h-16 text-white/60 mx-auto" />
                                                                    <div>
                                                                        <p className="text-xl font-semibold text-white mb-2">Upload Insurance Document</p>
                                                                        <p className="text-blue-200">PDF, DOC, or DOCX files up to 3MB</p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="file"
                                                                id="insuranceFileInput"
                                                                onChange={(e) => handleFileChange(e, "insurance")}
                                                                accept=".pdf,.doc,.docx"
                                                                className="hidden"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            )}

                                            <div>
                                                <label className="block mb-3 text-sm font-medium text-blue-100">
                                                    Do you have license documentation? *
                                                </label>
                                                <div className="flex gap-6">
                                                    <label className="flex items-center gap-2 cursor-pointer">
                                                        <input
                                                            type="radio"
                                                            name="license"
                                                            value="yes"
                                                            onChange={handleLicenseChange}
                                                            className="w-4 h-4 text-blue-600 bg-white border-2 border-gray-300 focus:ring-blue-500 focus:ring-2 transition-all duration-200"
                                                        />
                                                        <span className="text-blue-100">Yes</span>
                                                    </label>
                                                    <label className="flex items-center gap-2 cursor-pointer">
                                                        <input
                                                            type="radio"
                                                            name="license"
                                                            value="no"
                                                            onChange={handleLicenseChange}
                                                            className="w-4 h-4 text-blue-600 bg-white border-2 border-gray-300 focus:ring-blue-500 focus:ring-2 transition-all duration-200"
                                                        />
                                                        <span className="text-blue-100">No</span>
                                                    </label>
                                                </div>
                                            </div>

                                            {showLicenseDetails && (
                                                <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                                                    <div className="flex items-center gap-3 mb-4">
                                                        <FontAwesomeIcon icon={faFileAlt} className="w-4 h-4 text-blue-200" />
                                                        <h4 className="text-lg font-semibold text-white">Upload License Document</h4>
                                                    </div>
                                                    <div className="border-2 border-dashed border-white/30 rounded-xl p-8 text-center hover:border-white/50 transition-colors duration-200">
                                                        <label htmlFor="licenseFileInput" className="cursor-pointer block">
                                                            {selectedLicenseFile ? (
                                                                <div className="space-y-2">
                                                                    <div className="p-3 bg-green-500/20 rounded-lg inline-block">
                                                                        <FontAwesomeIcon icon={faFileAlt} className="w-8 h-8 text-green-300" />
                                                                    </div>
                                                                    <p className="text-white font-medium">{selectedLicenseFile.name}</p>
                                                                    <p className="text-blue-200 text-sm">Click to change file</p>
                                                                </div>
                                                            ) : (
                                                                <div className="space-y-4">
                                                                    <AiOutlineCloudUpload className="w-16 h-16 text-white/60 mx-auto" />
                                                                    <div>
                                                                        <p className="text-xl font-semibold text-white mb-2">Upload License Document</p>
                                                                        <p className="text-blue-200">PDF, DOC, or DOCX files up to 3MB</p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <input
                                                                type="file"
                                                                id="licenseFileInput"
                                                                onChange={(e) => handleFileChange(e, "license")}
                                                                accept=".pdf,.doc,.docx"
                                                                className="hidden"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Additional Comments Section */}
                                    <div className="bg-white/5 rounded-xl p-6 backdrop-blur-sm border border-white/10">
                                        <h3 className="text-xl font-semibold mb-6 text-white">Additional Information</h3>
                                        <div>
                                            <label htmlFor="comments" className="block mb-2 text-sm font-medium text-blue-100">
                                                Comments *
                                            </label>
                                            <textarea
                                                name="vendorDTO.comments"
                                                id="comments"
                                                placeholder="Please provide any additional information about your services, experience, or special requirements..."
                                                value={formData.vendorDTO.comments}
                                                onChange={handleChange}
                                                maxLength={200}
                                                rows={4}
                                                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-gray-900 placeholder-gray-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 shadow-sm resize-none"
                                            />
                                            {errors.comments && (
                                                <p className="mt-2 text-sm text-red-300 bg-red-500/10 px-3 py-2 rounded-lg border border-red-500/20">
                                                    {errors.comments}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Form Actions */}
                                    <div className="flex flex-col sm:flex-row gap-4 justify-end pt-6 border-t border-white/10">
                                        <button
                                            type="button"
                                            onClick={handleCancel}
                                            className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-xl transition-all duration-200 border border-white/20 hover:border-white/40 hover:scale-105 transform"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="px-8 py-3 bg-white hover:bg-gray-100 text-blue-800 font-semibold rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105 transform border border-white"
                                        >
                                            Submit Application
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className="hoa-footer-import">
                <HoaFooter />
            </div>
        </>
    );
};

export default HoaVendorOnBoard;